import React, { useEffect } from 'react';
import { clickPretBuyTicket } from "../../../../_utils/clickNext";
import $ from 'jquery';

export function ModalErrorEmail(props) {
  useEffect(() => {
    $(document.body).removeClass("modal-open");
  }, [])

  const handleClose = () => {
    clickPretBuyTicket("nextBuyTicket2");
  }

  return (
    <div className="modal fade" id="modalErrorEmail" tabIndex={-1} role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="false" data-keyboard="false" data-backdrop="static">
      <div className="modal-dialog reveal-modal" role="document">
        <div className="modal-content modal-content__community">
          <div className="modal-body">
            <div className="give_away_ticket__content">このメールを使ってチケットを購入したことがありますので、
他のメールでお試してください。</div>

            <div className="community__btn mt-4">
              <button className="btn schedule__but_return give_away_ticket__btn close__public"
                onClick={handleClose}
                data-dismiss="modal"
                aria-label="Close"
              >OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
